import { createAction } from "@reduxjs/toolkit";
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["setType"] = "search/setType";
    ActionTypes["setFrom"] = "search/setFrom";
    ActionTypes["setTo"] = "search/setTo";
    ActionTypes["setDateRange"] = "search/setDateRange";
    ActionTypes["setDepartureDate"] = "search/setDepartureDate";
    ActionTypes["setReturnDate"] = "search/setReturnDate";
    ActionTypes["setOccupancyAndCabinClass"] = "search/setOccupancyAndCabinClass";
    ActionTypes["setCabinClass"] = "search/setCabinClass";
    ActionTypes["setSortOrder"] = "search/setSortOrder";
    ActionTypes["setPage"] = "search/setPage";
    ActionTypes["setFiltersDraft"] = "search/setFiltersDraft";
    ActionTypes["setFiltersDraftOutbound"] = "search/setFiltersDraftOutbound";
    ActionTypes["setFiltersDraftInbound"] = "search/setFiltersDraftInbound";
    ActionTypes["resetFiltersDraft"] = "search/resetFiltersDraft";
    ActionTypes["resetFiltersDraftOutbound"] = "search/resetFiltersDraftOutbound";
    ActionTypes["resetFiltersDraftInbound"] = "search/resetFiltersDraftInbound";
    ActionTypes["applyFilters"] = "search/applyFilters";
    ActionTypes["applyFiltersOutbound"] = "search/applyFiltersOutbound";
    ActionTypes["applyFiltersInbound"] = "search/applyFiltersInbound";
    ActionTypes["resetFilters"] = "search/resetFilters";
    ActionTypes["resetFiltersOutbound"] = "search/resetFiltersOutbound";
    ActionTypes["resetFiltersInbound"] = "search/resetFiltersInbound";
    ActionTypes["swapFromTo"] = "search/swapFromTo";
    ActionTypes["resetFiltersButKeep"] = "search/resetFiltersButKeep";
    ActionTypes["setValueFromSB"] = "setValueFromSB";
    ActionTypes["resetFilter"] = "search/resetFilter";
    ActionTypes["resetFilterOutbound"] = "search/resetFilterOutbound";
    ActionTypes["resetFilterInbound"] = "search/resetFilterInbound";
})(ActionTypes || (ActionTypes = {}));
export const actions = {
    setSortOrder: createAction(ActionTypes.setSortOrder, (sort) => ({
        payload: { sort }
    })),
    setPage: createAction(ActionTypes.setPage, (page) => ({
        payload: { page }
    })),
    setFiltersDraft: createAction(ActionTypes.setFiltersDraft, (filtersDraft) => ({
        payload: { filtersDraft }
    })),
    setFiltersDraftOutbound: createAction(ActionTypes.setFiltersDraftOutbound, (filtersDraftOutbound) => ({
        payload: { filtersDraftOutbound }
    })),
    setFiltersDraftInbound: createAction(ActionTypes.setFiltersDraftInbound, (filtersDraftInbound) => ({
        payload: { filtersDraftInbound }
    })),
    resetFiltersDraft: createAction(ActionTypes.resetFiltersDraft, () => ({
        payload: {}
    })),
    resetFiltersDraftOutbound: createAction(ActionTypes.resetFiltersDraftOutbound, () => ({
        payload: {}
    })),
    resetFiltersDraftInbound: createAction(ActionTypes.resetFiltersDraftInbound, () => ({
        payload: {}
    })),
    applyFilters: createAction(ActionTypes.applyFilters, () => ({
        payload: {}
    })),
    applyFiltersOutbound: createAction(ActionTypes.applyFiltersOutbound, () => ({
        payload: {}
    })),
    applyFiltersInbound: createAction(ActionTypes.applyFiltersInbound, () => ({
        payload: {}
    })),
    resetFilters: createAction(ActionTypes.resetFilters, () => ({
        payload: {}
    })),
    resetFiltersOutbound: createAction(ActionTypes.resetFiltersOutbound, () => ({
        payload: {}
    })),
    resetFiltersInbound: createAction(ActionTypes.resetFiltersInbound, () => ({
        payload: {}
    })),
    resetFiltersButKeep: createAction(ActionTypes.resetFiltersButKeep, (filter) => ({
        payload: { filter }
    })),
    setValueFromSB: createAction(ActionTypes.setValueFromSB, (searchboxVal) => {
        return {
            payload: { searchboxVal }
        };
    }),
    resetFilter: createAction(ActionTypes.resetFilter, (filter) => ({
        payload: { filter }
    })),
    resetFilterOutbound: createAction(ActionTypes.resetFilterOutbound, (filter) => ({
        payload: { filter }
    })),
    resetFilterInbound: createAction(ActionTypes.resetFilterInbound, (filter) => ({
        payload: { filter }
    }))
};
